export function normalizePlayerTag(tag: string): string {
  return tag.startsWith("#") ? tag : `#${tag}`;
}

export function normalizeClanTag(tag: string): string {
  return tag.startsWith("#") ? tag : `#${tag}`;
}

export function toRouteTagParam(tag: string): string {
  return tag.replace(/^#/, "");
}
